export enum ApplicationCallStatus {
	SCHEDULED = 'SCHEDULED',
	CANCELLED = 'CANCELLED',
	COMPLETED = 'COMPLETED',
	CALLED_CUSTOMER_NO_ANSWER = 'CALLED_CUSTOMER_NO_ANSWER',
	CALLED_CUSTOMER_NO_ANSWER_ATTEMPTED_TO_LEAVE_VOICE_MAIL = 'CALLED_CUSTOMER_NO_ANSWER_ATTEMPTED_TO_LEAVE_VOICE_MAIL',
	CALLED_CUSTOMER_PARTIAL_DOCUMENTS_UPLOADED = 'CALLED_CUSTOMER_PARTIAL_DOCUMENTS_UPLOADED',
	CALLED_CUSTOMER_ALL_DOCUMENTS_UPLOADED = 'CALLED_CUSTOMER_ALL_DOCUMENTS_UPLOADED',
}

export namespace ApplicationCallStatus {
	export function toDisplayText(
		applicationCallStatus: ApplicationCallStatus
	): string {
		switch (applicationCallStatus) {
			case ApplicationCallStatus.SCHEDULED:
				return 'Scheduled';
			case ApplicationCallStatus.CANCELLED:
				return 'Cancelled';
			case ApplicationCallStatus.COMPLETED:
				return 'Completed';
			case ApplicationCallStatus.CALLED_CUSTOMER_NO_ANSWER:
				return 'Called Customer – No Answer';
			case ApplicationCallStatus.CALLED_CUSTOMER_NO_ANSWER_ATTEMPTED_TO_LEAVE_VOICE_MAIL:
				return 'Called Customer – No Answer, attempted to leave voice mail';
			case ApplicationCallStatus.CALLED_CUSTOMER_PARTIAL_DOCUMENTS_UPLOADED:
				return 'Called Customer – Partial Documents Uploaded';
			case ApplicationCallStatus.CALLED_CUSTOMER_ALL_DOCUMENTS_UPLOADED:
				return 'Called Customer – All Documents Uploaded';
			default:
				return applicationCallStatus;
		}
	}
}
